export const worldmapStyles = {
    statsCard: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '30px',
        borderRadius: '16px',
        marginBottom: '30px',
        boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    statsNumber: {
        fontSize: '48px',
        fontWeight: '700',
        marginBottom: '8px'
    },
    statsLabel: {
        fontSize: '16px',
        opacity: '0.9'
    },
    formSection: {
        backgroundColor: '#f8f9fa',
        padding: '30px',
        borderRadius: '16px',
        marginBottom: '30px',
        border: '1px solid #e9ecef',
        transition: 'all 0.3s ease'
    },
    listContainer: {
        backgroundColor: 'white',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
    },
    listHeader: {
        display: 'flex',
        padding: '20px 30px',
        backgroundColor: '#f8f9fa',
        fontWeight: '600',
        color: '#495057',
        fontSize: '14px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        borderBottom: '2px solid #e9ecef'
    },
    listItem: {
        padding: '25px 30px',
        borderBottom: '1px solid #e9ecef',
        alignItems: 'center',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f8f9fa',
            transform: 'translateX(5px)'
        }
    },
    imageContainer: {
        width: '100px',
        height: '100px',
        flexShrink: 0,
        borderRadius: '12px',
        overflow: 'hidden',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        border: '2px solid #e9ecef'
    },
    projectImage: {
        width: '80px',
        height: '80px',
        borderRadius: '12px'
    },
    posImage: {
        width: '120px',
        height: '120px',
        borderRadius: '16px',
        border: '3px solid #e9ecef'
    },
    eventImage: {
        width: '120px',
        height: '80px',
        borderRadius: '12px',
        border: '2px solid #f0f0f0'
    },
    button: {
        padding: '8px 16px',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.3s ease',
        marginRight: '8px'
    },
    editButton: {
        backgroundColor: '#0039d6',
        color: 'white',
        '&:hover': {
            backgroundColor: '#0052ff',
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(0, 57, 214, 0.3)'
        }
    },
    deleteButton: {
        backgroundColor: '#dc3545',
        color: 'white',
        '&:hover': {
            backgroundColor: '#c82333',
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)'
        }
    },
    searchBar: {
        width: '100%',
        padding: '16px 24px',
        border: '2px solid #e9ecef',
        borderRadius: '12px',
        fontSize: '16px',
        transition: 'all 0.3s ease',
        marginBottom: '30px',
        backgroundColor: 'white',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
        '&:focus': {
            outline: 'none',
            borderColor: '#0039d6',
            boxShadow: '0 0 0 3px rgba(0, 57, 214, 0.1)'
        }
    },
    emptyState: {
        textAlign: 'center',
        padding: '80px 20px',
        color: '#6c757d'
    },
    alert: {
        padding: '16px 20px',
        borderRadius: '12px',
        marginBottom: '20px',
        fontSize: '14px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        animation: 'slideIn 0.3s ease-out'
    },
    successAlert: {
        backgroundColor: '#d4edda',
        color: '#155724',
        border: '1px solid #c3e6cb'
    },
    errorAlert: {
        backgroundColor: '#f8d7da',
        color: '#721c24',
        border: '1px solid #f5c6cb'
    },
    badge: {
        display: 'inline-block',
        padding: '6px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '500',
        backgroundColor: '#e3f2fd',
        color: '#1976d2'
    },
    uploadSection: {
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        padding: '30px',
        borderRadius: '16px',
        marginBottom: '30px',
        border: '2px dashed #cbd5e0',
        transition: 'all 0.3s ease',
        cursor: 'pointer'
    },
    tabButton: {
        padding: '10px 20px',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.3s ease',
        marginRight: '10px',
        backgroundColor: '#e9ecef',
        color: '#495057'
    },
    activeTabButton: {
        backgroundColor: '#0039d6',
        color: 'white'
    },
    
    // Responsive breakpoints and styles
    responsive: {
        tablet: '768px',
        desktop: '1200px',
        largeDesktop: '1600px'
    }
};

// Add responsive CSS as a style tag
if (typeof document !== 'undefined' && !document.getElementById('worldmap-responsive-styles')) {
    const responsiveStyles = document.createElement('style');
    responsiveStyles.id = 'worldmap-responsive-styles';
    responsiveStyles.textContent = `
        /* POS Manager Responsive Styles */
        @media (min-width: 768px) {
            .pos-responsive-row {
                grid-template-columns: 120px 1fr 100px !important;
                gap: 25px !important;
                min-height: 140px;
            }
        }
        
        @media (min-width: 768px) and (max-width: 1200px) {
            .pos-responsive-row {
                grid-template-columns: 100px 1fr 90px !important;
                gap: 20px !important;
                padding: 20px !important;
                min-height: 120px;
            }
            .pos-main-image {
                width: 100px !important;
                height: 100px !important;
            }
        }
        
        @media (min-width: 1200px) {
            .pos-responsive-row {
                grid-template-columns: 140px 1fr 110px !important;
                gap: 30px !important;
                padding: 30px !important;
                min-height: 160px;
            }
            .pos-main-image {
                width: 140px !important;
                height: 140px !important;
            }
        }
        
        /* Event Manager Responsive Styles */
        @media (min-width: 768px) {
            .event-responsive-row {
                grid-template-columns: 120px 1fr 100px !important;
                gap: 25px !important;
                min-height: 120px;
            }
        }
        
        @media (min-width: 768px) and (max-width: 1200px) {
            .event-responsive-row {
                grid-template-columns: 100px 1fr 90px !important;
                gap: 20px !important;
                padding: 20px !important;
                min-height: 110px;
            }
            .event-logo-image {
                width: 100px !important;
                height: 70px !important;
            }
        }
        
        @media (min-width: 1200px) {
            .event-responsive-row {
                grid-template-columns: 140px 1fr 110px !important;
                gap: 30px !important;
                padding: 30px !important;
                min-height: 140px;
            }
            .event-logo-image {
                width: 140px !important;
                height: 90px !important;
            }
        }
        
        /* General responsive utilities */
        .text-ellipsis {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        
        .flex-no-wrap {
            flex-wrap: nowrap !important;
        }
        
        .min-width-0 {
            min-width: 0 !important;
        }
        
        /* Enhanced hover effects for better UX */
        .list-item-hover:hover .pos-main-image,
        .list-item-hover:hover .event-logo-image {
            transform: scale(1.03);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
        }
        
        .pos-main-image,
        .event-logo-image {
            transition: all 0.3s ease;
        }
        
        /* Icon button styling */
        .icon-button {
            transition: all 0.2s ease !important;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
            border: none !important;
            cursor: pointer !important;
        }
        
        .icon-button:hover {
            transform: translateY(-2px) scale(1.05) !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
        }
        
        .icon-button:active {
            transform: translateY(0) scale(0.95) !important;
            transition: all 0.1s ease !important;
        }
    `;
    document.head.appendChild(responsiveStyles);
}